import { useEffect, useRef } from 'react';

import { isEqual } from '../helpers/isEqual';

export const useNewApiCall = (
  callback: (signal?: AbortSignal) => Promise<void>,
  deps: any[]
) => {
  const prevDeps = useRef<any[] | null>(null);

  useEffect(() => {
    const hasChanged =
      !prevDeps.current ||
      deps.some((dep, index) => !isEqual(dep, prevDeps.current![index]));

    if (!hasChanged) return;

    const controller = new AbortController();

    const fetchData = async () => {
      try {
        if (controller.signal.aborted) return;
        await callback(controller.signal);
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error('API call error:', error);
        }
      }
    };

    fetchData();
    prevDeps.current = deps;

    return () => {
      controller.abort();
    };
  }, deps);
};
